import { render, staticRenderFns } from "./TeachingUserPaperForm.vue?vue&type=template&id=48922418&scoped=true"
import script from "./TeachingUserPaperForm.vue?vue&type=script&lang=js"
export * from "./TeachingUserPaperForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48922418",
  null
  
)

export default component.exports